<template>
	<div><h1>Configurações</h1></div>
</template>

<script>
export default {}
</script>

<style></style>
